module.exports = __webpack_public_path__ + "img/home-selected.aa97fdae.svg";